import React, { Component } from 'react';
import axios from 'axios';
import { Helmet } from "react-helmet";

// components
import Hero from '../components/Hero';

class Page extends Component {
  state = {
    isLoaded: false, faqs: [], campus: null, spList: null, short: null
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    document.querySelector('#main').classList.add('hero');

    let url = window.location.pathname;

    switch(url.split('/')[1]) {
      case 'austin':
        this.setState({ campus : 'txau', spList : 'e2056a0d-1015-4523-8b1b-6ec6cbe77e9c' }); break;
      case 'dallas':
        this.setState({ campus : 'txda', spList : '9c705379-cb17-41e6-9668-92b729501046' }); break;
      case 'san-marcos':
        this.setState({ campus : 'casm', spList : '8fe4fc1c-5cf6-4e26-a54e-fe9936fa3466' }); break;
      case 'miami':
        this.setState({ campus : 'flmi', spList : '53b3c4a1-f6c3-4f91-b4ea-ce16769f0c63' }); break;
      case 'st-augustine':
        this.setState({ campus : 'flsa', spList : '67c6418b-ded1-4965-b6d6-aa76f8b32589' }); break;
      default:
        return '';
    }

    setTimeout(() => {
      const SPAPI = process.env.REACT_APP_SHAREPOINTAPI;
      const data = {
        'usahstoken': process.env.REACT_APP_SECURITYTOKEN
      };
      const config = {
        method: 'post',
        url: process.env.REACT_APP_TOKENURL,
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          'Access-Control-Allow-Origin': '*'
        },
        data: JSON.stringify(data)
      };

      axios(config)
      .then((res) => {
        let token = res.data.access_token;
        let listid = this.state.spList;

        axios.get(SPAPI+'/'+listid+'/items?expand=fields(select=id,Title,Description)', {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        })
        .then((res) => {
          res.data.value.forEach(element => {
            this.state.faqs.push(element.fields);
            this.setState({ isLoaded: true });
            setTimeout(() => { this.setActive(this.state.campus) }, 25);
          });
        });
      })
      .catch((error) => {
        console.dir(error);
      });
    }, 25);
  }

  toggle = (e) => {
    e.preventDefault();
    let thisItem = e.target.parentElement.parentElement;

    if(thisItem.classList.contains('open')) {
      thisItem.classList.remove('open');
      thisItem.lastChild.style.height = '0px';
    } else {
      let allItems = document.querySelectorAll('.accordion .item');
      allItems.forEach((e) => {
        e.classList.remove('open');
        e.lastChild.style.height = '0px';
      });

      let body = thisItem.querySelector('.body');
      thisItem.classList.add('open');
      thisItem.lastChild.style.height = (body.scrollHeight + 12) + 'px';
    }
  }

  setActive = (e) => {
    document.querySelector('ol.breadcrumb .'+e).classList.add('active');
  }

  render() {
    const { isLoaded, campus, faqs } = this.state;
    const contentOnly = (window.location.search.indexOf('contentonly') > -1) ? true : false;

    return (
      <>
      {(isLoaded === false) && (
        <div className="preloader">
          <div className="loader"></div>
        </div>
      )}

      {isLoaded && (
        <>
        <Helmet>
          <title>{ campus.toUpperCase() } Housing FAQs :: USAHS</title>
          <link rel="canonical" href={ window.location.href } />
          <meta property="og:url" content={ window.location.href } />
        </Helmet>

        <Hero title="Housing FAQs" campus={ campus } />
        <div className="faqs">
          <div className="container-fluid">
            <div className="row">

              <div className="container">
                <div className="row">

                  <div className="col-12">
                    {(contentOnly === false) && (
                      <nav aria-label="breadcrumb">
                        <ol className="breadcrumb">
                          <li className="breadcrumb-item flsa"><a href="/st-augustine/faqs">St. Augustine, FL</a></li>
                          <li className="breadcrumb-item flmi"><a href="/miami/faqs">Miami, FL</a></li>
                          <li className="breadcrumb-item txau"><a href="/austin/faqs">Austin, TX</a></li>
                          <li className="breadcrumb-item txda"><a href="/dallas/faqs">Dallas, TX</a></li>
                          <li className="breadcrumb-item casm"><a href="/san-marcos/faqs">San Marcos, CA</a></li>
                        </ol>
                      </nav>
                    )}

                    {/* <p>These apartment listings are static pages from the full <strong>University of St. Augustine Student Housing Portal</strong>. Students will receive full access to the Student Housing Portal, including the ability to post roommate requests and review private rental listings, once they have been admitted to the university and have activated their student email address.</p> */}

                    <div className="accordion" id="faqs">
                      {/* START */}
                      {faqs.map((f, index) =>
                        <div className="item" key={ index }>
                          <h2 className="header">
                            <button className="button" type="button" onClick={ this.toggle }>
                              <span>{ f.Title }</span><i className="fas fa-arrow-alt-circle-right"></i>
                            </button>
                          </h2>
                          <div className="body">
                            <div className="bodyCont">
                              <p dangerouslySetInnerHTML={{ __html: f.Description.replace(/<span .*?>/g,"") }} />
                            </div>
                          </div>
                        </div>
                      )}
                      {/* END */}
                    </div>

                    {/* <p className="footnote"><i className="fas fa-plus-square" title="Preferred Community"></i> Preferred Community</p> */}
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
        </>
      )}
      </>
    );
  }
}

export default Page;